import {Button, InputGroup} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Form from 'react-bootstrap/Form';
import InputGroupText from "react-bootstrap/InputGroupText";
import {usePlayer, usePlayerState} from "../../Context/PlayerContext.tsx";
import HashDao, {HashValue} from "../../lib/hashDAO.ts";


export const Loops = () => {

    const player = usePlayer();
    const playerState = usePlayerState();


    let loops = [<option value={-1} key={-1}>select saved loop</option>]

    const [editDisabled, setEditDisabled] = useState(true)
    const [editableLoopName, setEditableLoopName] = useState(playerState.activeLoopName)

    for (let i = 0; i < playerState.loops.length; i++) {
        let loop = playerState.loops[i]
        loops.push(<option key={"loop-" + i} value={i} name={loop.name}>{loop.name}</option>)
    }



    const handleInputKeyDown = (e) => {
        e.stopPropagation(); // Stop the event from bubbling up to the global listener
    };

    return <div>
        <InputGroup>
            <Form.Select aria-label="" value={playerState.activeLoopIndex == null ? -1 : playerState.activeLoopIndex} onChange={
                (e) => {
                    if(e.target.value > -1 ) {
                        player.playLoop(e.target.value)
                    }
                }
            }>
                {loops}
            </Form.Select>
        </InputGroup>
        <InputGroup>
            {editDisabled &&
                <Button disabled={!(playerState.activeRegion && playerState.activeLoopIndex != null)}
                        variant={"outline-dark"}
                        onMouseDown={() => setEditDisabled(false)}>
                    <i className="bi bi-pencil"></i>
                </Button>
            }
            {!editDisabled &&
                <Button variant={"outline-dark"} onMouseDown={() =>{
                    setEditDisabled(true)
                    player.renameLoop(playerState.activeLoopIndex, editableLoopName)
                }}>
                    <i className="bi bi-check-circle"></i>
                </Button>
            }
            <Form.Control
                variant={"outline-dark"}
                as={"input"}
                type="text"
                aria-describedby="btnGroupAddon"
                className={"p-2"}
                disabled={editDisabled}
                placeholder={editableLoopName}
                defaultValue={editableLoopName}
                onKeyDown={handleInputKeyDown}
                onKeyPress={handleInputKeyDown}
                onKeyUp={handleInputKeyDown}
                onChange={(e) => setEditableLoopName(e.target.value)}
            />
            <Button disabled={!playerState.activeRegion}
                    variant={"outline-dark"}
                    onMouseDown={() => {
                        player.saveLoop()
                        setEditDisabled(true)
                    }}
                    // onClick={() => {
                    //     player.saveLoop()
                    //     setEditDisabled(true)
                    // }}
            >
                <i className="bi bi-save"></i>
            </Button>
            <Button disabled={!playerState.activeRegion}
                    variant={"outline-dark"}
                    onMouseDown={() => player.deleteLoop(playerState.activeLoopIndex)}>
                <i className="bi bi-trash"></i>
            </Button>
        </InputGroup>


    </div>
}

